import { render, staticRenderFns } from "./SundryOrderItemsTable.vue?vue&type=template&id=18362d7d&"
import script from "./SundryOrderItemsTable.vue?vue&type=script&lang=js&"
export * from "./SundryOrderItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./SundryOrderItemsTable.vue?vue&type=style&index=0&id=18362d7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports